import { SECTION } from '@aytm/app/stats/page/data-quality-report/lib/sections'

export const SECTION_STATE = {
  ACTIVE: 'active',
  FIELDING_IN_PROGRESS: 'fielding_in_progress',
  // The /dqr request is still in flight. Greyed + locked like fielding, but it's a transient
  // fetch rather than a survey-lifecycle state, so it carries no explanatory popup.
  LOADING_DATA: 'loading_data',
  // The /dqr request failed and no report was ever committed. Terminal until the author retries —
  // without it a failed fetch is indistinguishable from a load that never finishes.
  LOAD_FAILED: 'load_failed'
}

// PRD Part D — readiness predicate per section. true => active, false => greyed.
const READY = {
  [SECTION.PAID_VIEWPOINT]: () => true,
  [SECTION.TRAFFIC_SENTINEL]: () => true,
  [SECTION.SURVEY_DESIGN]: () => true,
  // The embedded engine reads nothing from the report and owns its own empty state, so this section
  // is ready whatever the payload carries.
  [SECTION.DATA_CENTRIFUGE]: () => true,
  [SECTION.HUMAN_REVIEW]: f => Boolean(f.humanReview),
  [SECTION.SURVEY_PERFORMANCE]: f => Boolean(f.surveyPerformance)
}

export const resolveSectionState = (section, fielding = {}) =>
  READY[section](fielding) ? SECTION_STATE.ACTIVE : SECTION_STATE.FIELDING_IN_PROGRESS
